import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Loading.css";

const Loading = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => {
            setVisible(false);
            if (onComplete) onComplete();
          }, 400);
          return 100;
        }
        return prev + 2;
      });
    }, 20);
    return () => clearInterval(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="loader-wrapper"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 1.05 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          {/* Background blobs */}
          <div className="loader-blob loader-blob-1" />
          <div className="loader-blob loader-blob-2" />

          <div className="loader-content">
            {/* Logo / Name */}
            <motion.div
              className="loader-logo"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <span className="loader-logo-bracket">&lt;</span>
              <span className="loader-logo-name">ShabinSV</span>
              <span className="loader-logo-bracket">/&gt;</span>
            </motion.div>

            {/* Tagline */}
            <motion.p
              className="loader-tagline"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              Full Stack Developer
            </motion.p>

            {/* Animated rings */}
            <div className="loader-rings">
              <motion.div
                className="loader-ring loader-ring-1"
                animate={{ rotate: 360 }}
                transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
              />
              <motion.div
                className="loader-ring loader-ring-2"
                animate={{ rotate: -360 }}
                transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
              />
              <motion.div
                className="loader-ring loader-ring-3"
                animate={{ rotate: 360 }}
                transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
              />
            </div>

            {/* Progress bar */}
            <motion.div
              className="loader-bar-wrapper"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              <div className="loader-bar-track">
                <motion.div
                  className="loader-bar-fill"
                  style={{ width: `${progress}%` }}
                />
              </div>
              <span className="loader-percent">{progress}%</span>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loading;
